import Choices from 'choices.js';
import { constants } from './constants.js';

import * as helpers from './helpers.js';
import * as productsMenu from './products-menu.js'
import * as shopify from './shopify.js';
import * as state from './state.js';

// we are responsible for the UI that relates to country selection/display.
// in particular, the country selection dropdowns on the page
// we also are responsible for any changes to the current country made by the
// user or other parts of the app.

// in response to a country change, we update the state and the
// country-selection UI if we are currently on a cart page, we may need to take
// the user to a new cart.

let choicesList = [];

function init() {
  let sortedCountryOptionList = getSortedCountryOptionList();
  // console.log(sortedCountryOptionList);

  let countrySelectorElements =
      document.querySelectorAll('.sal-country-selector');
  countrySelectorElements.forEach((element) => {
    let option = document.createElement('option');
    option.value = state.getCountryIso();
    option.text = state.getCountryName();
    element.add(option);
    // element.value = state.getCountryIso();

    // https://github.com/jshjohnson/Choices
    const choices = new Choices(element, {
      removeItemButton: true,
      searchPlaceholderValue: 'Search for your country',
      renderChoiceLimit: 4,
      searchResultLimit: 4,
      searchFields: ['label'],
    });
    choices.setChoices(sortedCountryOptionList, 'value', 'label', true);
    choicesList.push(choices);

    element.onchange = event => changeCountry(event.target.value);
  });
}

function getSortedCountryOptionList() {
  const countries = shopify.getAllCountries();
  // key:value =>  iso:name
  // sort by the names of the country, i.e. the value

  const sortedKeys = Object.keys(countries).sort((key1, key2) => {
    if (countries[key1] < countries[key2]) return -1;

    return 1;
  });

  let sortedList = [];
  sortedKeys.forEach((key) => {
    let obj = {value: key, label: countries[key]};
    sortedList.push(obj);
  });
  return sortedList;
}

function changeCountry(newCountry) {
  // called by our UI on country change
  // if we're on a cart page, we may need to navigate to a new cart

  // also called shopify.checkForCountryCurrencyMismatch() if the user has gone
  // to a cart that doesn't match the current country in this case we set the
  // state below, but after that the currency/country will match and no redirect
  // will occur.

  state.setCountryIso(newCountry);

  productsMenu.updatePrices();
  choicesList.forEach(choices => {  // update ui
    let val = choices.getValue(true);
    if (val !== newCountry) choices.setValueByChoice(newCountry);
  });

  if (helpers.isHomePage()) return;
  if (helpers.isBlog()) return;
  if (helpers.isSupport()) return;

  const cartCurrency = shopify.getCurrencyFromCartUrl();
  const stateCurrency = state.getCurrency();  // iso, caps

  if (cartCurrency === stateCurrency) return;

  // the user just changed the country, and we must change to a new cart
  // however, we must make sure that shopify-cart-sync.init is finished saving
  // the current cart state to a cookie

  helpers.callOnFinished(() => {
    // When navigating to a different currency store we need to strip the 
    // variant id and replace it with that stores variant id
    let params = (new URL(document.location)).searchParams;
    let sku = params.get("variant-sku");
    let variantId = '';
    
    if (sku) {
      variantId = constants.productDataByCurrency[stateCurrency][sku].id;
    }

    if (variantId) {
      shopify.navigateToStoreWithPath(window.location.pathname + '?variant=' + variantId);
    } else {
      shopify.navigateToStoreWithPath(window.location.pathname);
    }
    
  });
}

export {
  init,
  changeCountry,
};
